import React, { useState } from 'react';
// import { Row, Col, Table, Card, Form, Input, DatePicker, Select, Button } from 'antd';
import DataEntry from '../payments_data_entry';

const isEditting = true;

export default function DetailsPage(props){
    // console.log("🚀 ~ file: index.jsx ~ line 8 ~ DetailsPage ~ props", props)
    
    const [invoiceDetails] = useState(props);
    return(
        <div>
            <DataEntry 
                // invoiceDetails={invoiceDetails} 
                invoiceDetails={invoiceDetails.location.state} 
                isEditting={isEditting}
            />
        </div>
    );
}

